export const styles = {
  infoBoxContainer: {
    width: "100%",
    color: "white",
  },
  disclaimer: {
    color: "gray.muted1",
  },
  infoBoxList: {
    position: "unset",
  },
  infoBoxListItem: {
    position: "unset",
  },
  infoBoxListItemText: {
    fontSize: "typography.h4.fontSize",
  },
};
